const borderRadius = {
  small: 4,
  mediumSmall: 8,
  medium: 12,
  large: 100,
};

export default borderRadius;
